import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function Faq() {
  const [openId, setOpenId] = useState<string | null>('f1');

  return (
    <section id="faq" className="w-full bg-background-900/40 py-16 md:py-24">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="mb-10 text-center">
          <span className="mb-3 inline-flex items-center gap-1.5 text-sm font-medium text-accent-400">
            <i className="ri-question-line" />
            FAQ
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-50 md:text-4xl">
            常见问题
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-foreground-400 md:text-base">
            关于编辑推荐、追更提醒和书单使用，你想知道的都在这里。
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((item) => {
            const open = openId === item.id;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-xl border transition-colors ${
                  open ? 'border-primary-500/50 bg-background-950' : 'border-background-800 bg-background-950'
                }`}
              >
                <button
                  type="button"
                  aria-expanded={open}
                  onClick={() => setOpenId(open ? null : item.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="flex items-center gap-3 text-sm font-bold text-foreground-100 md:text-base">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs ${open ? 'bg-primary-500 text-foreground-950' : 'bg-background-800 text-primary-400'}`}>
                      Q
                    </span>
                    {item.q}
                  </span>
                  <i
                    className={`shrink-0 text-xl text-primary-400 transition-transform ${open ? 'ri-subtract-line' : 'ri-add-line'}`}
                  />
                </button>
                {open && (
                  <div className="px-5 pb-5 pl-[3.75rem]">
                    <p className="text-sm leading-relaxed text-foreground-400">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}